/**
 * Returns the product and lens features from a given variant
 */ const getContactLensFeatures = (variant, getLabel)=>{
    const productFeatures = [
        {
            labelKey: 'products.contactLenses.materialType',
            attribute: 'materialType',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.lensType',
            attribute: 'lensType',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.material',
            attribute: 'material',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.waterContent',
            attribute: 'waterContent',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.features.uv',
            attribute: 'features.uv',
            isLocalised: true
        }, 
    ];
    const hydration = {
        label: getLabel('products.contactLenses.features.hydration'),
        variantHasAttribute: (()=>!!variant.features.hydration
        )()
    };
    const softness = {
        label: getLabel('products.contactLenses.features.softness'),
        variantHasAttribute: (()=>!!variant.features.softness
        )()
    };
    const breathability = {
        label: getLabel('products.contactLenses.features.breathability'),
        variantHasAttribute: (()=>!!variant.features.breathability
        )()
    };
    const fatigue = {
        label: getLabel('products.contactLenses.features.eyeFatigue'),
        variantHasAttribute: (()=>!!variant.features.fatigue
        )()
    };
    const uv = {
        label: getLabel('products.contactLenses.features.uv'),
        variantHasAttribute: (()=>!!variant.features.uv
        )()
    };
    const basics = {
        label: getLabel('products.contactLenses.features.basics'),
        variantHasAttribute: (()=>!!variant.features.basics
        )()
    };
    const lensFeatures = {
        hydration,
        softness,
        breathability,
        fatigue,
        uv,
        basics
    };
    return {
        productFeatures,
        lensFeatures
    };
};

export { getContactLensFeatures };
//# sourceMappingURL=get-contactlens-features.js.map
